import styled from "@emotion/styled"

interface IStyledContentContainer {
  isTableLayout?: boolean
}
const StyledContentContainer = styled.div<IStyledContentContainer>`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  ${({ theme, isTableLayout }) => `
    ${
      isTableLayout && `height: 100%;` // Height definition is needed to make swiper work (https://stackoverflow.com/questions/56116823/swiper-really-weird-behaviour-when-parent-is-flex)
    };
    ${theme.breakpoints.down("sm")} {
      padding: ${isTableLayout ? 0 : `${theme.spacing(3)} ${theme.spacing(2)}`};
    }
  `}

  ${({ theme }) => theme.breakpoints.up("sm")} {
    padding: ${({ theme }) => `${theme.spacing(3)} ${theme.spacing(8)}`};
  }
`

export default StyledContentContainer
